module.exports = __webpack_public_path__ + "img/usCover.91acfd34.png";